import { Link } from 'react-router-dom'

const categories = [
  { slug: 'love', name: '恋爱', icon: 'ri-heart-line', color: 'bg-primary-500', count: 1280, desc: '甜蜜浪漫的恋爱故事' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line', color: 'bg-accent-500', count: 960, desc: '奇幻世界的冒险旅程' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line', color: 'bg-secondary-500', count: 850, desc: '热血激战燃到爆' },
  { slug: 'suspense', name: '悬疑', icon: 'ri-search-eye-line', color: 'bg-foreground-700', count: 620, desc: '烧脑推理悬疑大作' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', color: 'bg-accent-400', count: 740, desc: '爆笑日常欢乐不断' },
  { slug: 'horror', name: '惊悚', icon: 'ri-ghost-line', color: 'bg-foreground-600', count: 390, desc: '细思极恐的恐怖故事' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line', color: 'bg-primary-400', count: 560, desc: '温馨治愈的日常篇章' },
  { slug: 'history', name: '古风', icon: 'ri-ancient-gate-line', color: 'bg-secondary-600', count: 430, desc: '唯美古风穿越之旅' },
]

const emojis = ['💕', '✨', '⚔️', '🔍', '😂', '👻', '🌿', '🏯']

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs uppercase tracking-widest text-foreground-500 font-medium mb-3">漫画分类</p>
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-900 leading-tight">
            探索你喜欢的 {emojis[0]}<br />漫画类型
          </h2>
          <p className="mt-4 text-sm text-foreground-600 max-w-md mx-auto">
            八大分类，涵盖所有韩漫类型，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-lg aspect-[3/4]"
            >
              <div className={`absolute inset-0 ${cat.color} opacity-90 group-hover:opacity-100 transition-opacity`}></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-background-50/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${cat.icon} text-background-50 text-2xl md:text-3xl`}></i>
                </div>
                <h3 className="text-xl md:text-2xl font-heading text-background-50 mb-2">
                  {cat.name} {emojis[index]}
                </h3>
                <p className="text-sm text-background-50/80 mb-4">{cat.desc}</p>
                <span className="text-xs text-background-50/60 bg-background-50/10 px-3 py-1 rounded-full whitespace-nowrap">
                  {cat.count}+ 部作品
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}